import React from "react";
import { Contract } from "@ethersproject/contracts";
import tokenAbi from "./TokenContract.json";
import mainNodeAbi from "./MainNodeContract.json";
import NodesAbi from "./NodesContract.json";
import nodePresaleAbi from "./nodePresaleContract.json";
import StakeAbi from "./StakeContract.json";
import {
  tokenAddress,
  node1Address,
  node2Address,
  node3Address,
  usdcAddress,
  lpAddress,
  mainNodeAddress,
  nodePresaleAddress,
  stakingAddress,
  LpTokenAddress,
  BscContract,
  bscTokenContract,
  EthContract,
  ethTokenContract,
} from "./Environment";
import bscTokenAbi from "./bscTokenAbi.json";
import ethTokenAbi from "./ethTokenAbi.json";
import EthAbi from "./EthAbi.json";
import BscAbi from "./BscAbi.json";

import { ethers } from "ethers";
import { Alert, Snackbar } from "@mui/material";
let walletAddress = "0x8ba1f109551bD432803012645Ac136ddd64DBA72";

const provider = new ethers.providers.JsonRpcProvider(
  "https://data-seed-prebsc-1-s1.binance.org:8545/"
);

const VoidSigner = new ethers.VoidSigner(walletAddress, provider);

function useContract(address, ABI, signer) {
  return React.useMemo(() => {
    if (signer) {
      return new Contract(address, ABI, signer);
    } else {
      return new Contract(address, ABI, VoidSigner);
    }
  }, [address, ABI, signer]);
}
const bscProvider = new ethers.providers.JsonRpcProvider(
  "https://data-seed-prebsc-1-s1.binance.org:8545/"
);
const ethProvider = new ethers.providers.JsonRpcProvider(
  "https://ropsten.infura.io/v3/9aa3d95b3bc440fa88ea12eaa4456161"
);

export const bscVoidAccount = new ethers.VoidSigner(walletAddress, bscProvider);
export const ethVoidAccount = new ethers.VoidSigner(walletAddress, ethProvider);
function useBscContract(address, ABI, signer) {
  return React.useMemo(() => {
    if (signer) {
      return new Contract(address, ABI, signer);
    } else {
      return new Contract(address, ABI, bscVoidAccount);
    }
  }, [address, ABI, signer]);
}
function useEthContract(address, ABI, signer) {
  return React.useMemo(() => {
    if (signer) {
      return new Contract(address, ABI, signer);
    } else {
      return new Contract(address, ABI, ethVoidAccount);
    }
  }, [address, ABI, signer]);
}
export function useBscTokenContract(signer) {
  return useBscContract(bscTokenContract, bscTokenAbi, signer);
}
export function useEthTokenContract(signer) {
  return useEthContract(ethTokenContract, ethTokenAbi, signer);
}

export function useEthBridgeContract(signer) {
  return useBscContract(EthContract, EthAbi, signer);
}
export function useBscBridgeContract(signer) {
  return useBscContract(BscContract, BscAbi, signer);
}

export function useUsdcContract(signer) {
  return useContract(usdcAddress, tokenAbi, signer);
}

export function useLpContract(signer) {
  return useContract(lpAddress, tokenAbi, signer);
}

export function useTokenContract(signer) {
  return useContract(tokenAddress, tokenAbi, signer);
}

export function useMainnodeContract(signer) {
  return useContract(mainNodeAddress, mainNodeAbi, signer);
}

export function useNodePresaleContract(signer) {
  return useContract(nodePresaleAddress, nodePresaleAbi, signer);
}

export function useNode1Contract(signer) {
  return useContract(node1Address, NodesAbi, signer);
}

export function useNode2Contract(signer) {
  return useContract(node2Address, NodesAbi, signer);
}

export function useNode3Contract(signer) {
  return useContract(node3Address, NodesAbi, signer);
}

export function useStakingContract(signer) {
  return useContract(stakingAddress, StakeAbi, signer);
}

export function ToastNotify({ alertState, setAlertState }) {
  return (
    <Snackbar
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
      open={alertState.open}
      autoHideDuration={3000}
      key={"top" + "center"}
      onClose={() => setAlertState({ ...alertState, open: false })}
    >
      <Alert
        onClose={() => setAlertState({ ...alertState, open: false })}
        severity={alertState.severity}
      >
        {alertState.message}
      </Alert>
    </Snackbar>
  );
}

export function toPlainString(num) {
  return ("" + +num).replace(
    /(-?)(\d*)\.?(\d*)e([+-]\d+)/,
    function (a, b, c, d, e) {
      return e < 0
        ? b + "0." + Array(1 - e - c.length).join(0) + c + d
        : b + c + d + Array(e - d.length + 1).join(0);
    }
  );
}
